import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { TariffDimensionType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/enums/ocpi-protocol-enums';
import { TariffElementModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/shared/tariff-element.model';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/tariffs/tariff.model';
import { useMemo } from 'react';

import { ComplexTariffCardComponent } from './cards/complex-tariff-card.component';
import { FlatCardComponent } from './cards/flat-card.component';
import { InformationCardComponent } from './cards/information-card.component';
import { SimpleTariffCardComponent } from './cards/simple-tariff-card.component';

// TODO: Should be moved in SDK
const hasRestrictions = (element: TariffElementModel) => {
  if (!element.restrictions) {
    return false;
  }
  return (
    (element.restrictions.day_of_week &&
      element.restrictions.day_of_week.length > 0) ||
    element.restrictions.start_time ||
    element.restrictions.end_time
  );
};

interface EmspBoTariffDetailsViewProps {
  resource: TariffModel;
}

export const EmspBoTariffDetailsView = ({
  resource,
}: EmspBoTariffDetailsViewProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // TODO: Should be moved in SDK
  const hasFlat = useMemo(
    () =>
      resource.elements[0]?.price_components.some(
        (p) => p.type === TariffDimensionType.FLAT,
      ),
    [resource],
  );

  // TODO: Should be moved in SDK
  const hasNonFlatComponents = useMemo(
    () =>
      resource.elements[0]?.price_components.some(
        (p) => p.type !== TariffDimensionType.FLAT,
      ) ?? false,
    [resource],
  );

  // TODO: Should be moved in SDK
  const isComplexTariff = useMemo(
    () =>
      resource.elements.length >= 2 || resource.elements.some(hasRestrictions),
    [resource],
  );

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // TABS //////////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack gap={GapEnum.M} direction="column">
      <InformationCardComponent tariff={resource} />
      <Divider />
      {hasFlat && <FlatCardComponent tariff={resource} />}
      {!isComplexTariff && hasNonFlatComponents && (
        <SimpleTariffCardComponent tariff={resource} />
      )}
      {isComplexTariff && <ComplexTariffCardComponent tariff={resource} />}
    </Stack>
  );
};
